import { useAuthenticator } from '@aws-amplify/ui-react';
import { Navigate, useLocation } from 'react-router-dom';
import GradientCircularProgressContainer from '../common/GradientCircularProgressContainer';
import SessionInactivityWarningModal from '../user/SessionActivityWarningModal';

interface AuthWrapperProps {
  children: React.ReactNode;
}
const AuthWrapper: React.FC<AuthWrapperProps> = ({ children }) => {
  const { authStatus } = useAuthenticator((context) => [context.authStatus, context.user]);
  const location = useLocation();

  if (authStatus === 'configuring') {
    return <GradientCircularProgressContainer />;
  }

  if (authStatus !== 'authenticated') {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return (
    <>
      <SessionInactivityWarningModal />
      {children}
    </>
  );
};

interface ProtectedRouteProps {
  element: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ element }) => {
  return <AuthWrapper>{element}</AuthWrapper>;
};

export default ProtectedRoute;
